const INITIAL_STATE = {
  balanceSheet: { values: [], error: null, loading: false },
};

export default function (state = INITIAL_STATE, action) {
  return {
    ...state,
    balanceSheet: { values: action.payload, error: null, loading: true },
  };
}
